/**
 * Export all data which must be globally available in the application. 
 * Typically this data includes settings and company data.
 * Note that the default objects are not intended to be edited. 
 * The reason is that those object provide configuration for the application. We do not want to 
 * have unsaved changes reflected in the application.
 * 
 * For editing globals use:   const editableCompany = globals.company.clone(); 
 * When saving, the data will be propagated to the global instance automatically.
 * 
 * import {globals} from '@app/globals'
 * 
 *      const company = globals.company
 *      const user = globals.user
 *      const datatables = globals.datatables
 *      const manday = globals.manday
 *      const document = globals.document
 *      const salesinvoice = globals.salesinvoice
 *      const purchaseinvoice = globals.purchaseinvoice
 *      const dashboard = globals.dashboard
 *      const salesorder = globals.salesorder
 *      const portal = globals.portal
 * 
 */

import {ref} from 'vue'
import eventbus from '@app/eventbus'
import clsGlobalCompany from './company'
import clsGlobalPurchaseInvoice from './purchaseinvoice'
import clsGlobalMandays from './manday'
import clsGlobalSalesOrders from './salesorder'
import clsGlobalPortal from './portal'
import clsGlobalDashboard from './dashboard'
import clsGlobalSalesInvoice from './salesinvoice'
import clsGlobalUser from './user'
import clsGlobalDocument from './document'

import clsDatatableSettings  from './datatable'

class clsGlobalManager {

    company         = ref(new clsGlobalCompany("company")).value;
    purchaseinvoice = ref(new clsGlobalPurchaseInvoice("purchaseinvoice")).value;
    manday          = ref(new clsGlobalMandays("manday")).value;
    salesorder      = ref(new clsGlobalSalesOrders("salesorder")).value;
    portal          = ref(new clsGlobalPortal("portal")).value;
    dashboard       = ref(new clsGlobalDashboard("dashboard")).value;
    salesinvoice    = ref(new clsGlobalSalesInvoice("salesinvoice")).value;
    user            = ref(new clsGlobalUser("user")).value;
    document        = ref(new clsGlobalDocument("document")).value;
    datatable       = ref(new clsDatatableSettings("datatable")).value;

    /**
     * Register for events.
     */
    registerEvents() {
        var self = this;
        eventbus.appdata.loaded.on(  (data) => {
            if (!data || !data.settings) {
                return;
            }
            for (var modelName in data.settings) {
                if (!self[modelName]) { 
                    console.log('Skipping', modelName);
                    continue;
                }
                // Depending on the model is reactive or not the value may be in .value or not
                if (self[modelName].fill) {
                    self[modelName].fill(data.settings[modelName]);    
                } else {
                    throw new Error('No fill method found for '+ modelName);
                }
            }
        })
    }

    constructor() {
        this.registerEvents();
    }

}

const mgr = new clsGlobalManager();

export default mgr;
